module.exports = __webpack_public_path__ + "media/icons/arrow-up-2@2x-ee38f8da.png";